import * as Sentry from "@sentry/react";

// Fraction of transactions sent to Sentry in production (0.0–1.0).
// Temporarily set to 1.0 to get full visibility while traffic is low.
// TODO: reduce to 0.2 once user base grows.
const PRODUCTION_TRACES_SAMPLE_RATE = 1.0;

export function initSentry(appName: 'webapp-app' | 'webapp-admin') {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not configured, error tracking disabled");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_ENVIRONMENT ?? import.meta.env.MODE,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'prod' ? PRODUCTION_TRACES_SAMPLE_RATE : 1.0,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    tracePropagationTargets: [
      "localhost",
      /^https:\/\/api-dev\.fakto\.ai/,
      /^https:\/\/api\.fakto\.ai/,
    ],

    initialScope: {
      tags: { appName },
    },

    beforeSend(event: Sentry.ErrorEvent) {
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
      }
      return event;
    },
  });
}

export function setSentryUser(email: string, organizationSlug?: string) {
  Sentry.setUser({
    email,
    ...(organizationSlug && { username: organizationSlug }),
  });
}

export function setSentryAdmin(email: string) {
  Sentry.setUser({
    email,
    segment: 'admin',
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}

export { Sentry };
